module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-black.90a91b66.svg";